import React, { useEffect, useState } from "react";
import { CloseIcon } from "../../../../../Assets/Icons/svg";
import { Modal, TextArea } from "semantic-ui-react";
import { useSignaturePadModal } from "../../../../../hooks/useSignaturePadModal";
import { imageUrlToFile, uploadFile } from "../../../../config/api/configApis";
import {
  addUserSignature,
  getUserSignature,
} from "../../../../config/api/peopleApis";
import { toast } from "react-toastify";
import useModuleFlag from "../../../../../hooks/useModuleFlag";
import { LDCONSTANTS } from "../../../../config/LDconstants";

const StatusChangeModal = ({
  selectedLanguage,
  loading,
  onHoldFlag,
  reOpenFlag,
  setMessage,
  message,
  handleSave,
  setAddedSignature,
  addedSignature,
  t,
  assigneeCondition,
  openModal,
  openFlag,
  closeFlag,
  inCancleFlag,
  setModal,
  approveModal,
  inProgressFlag,
}) => {
  const { SignaturePadModal, openSignaturePad } = useSignaturePadModal();
  const [signatures, setSignatures] = useState([]);

  const maxCount = useModuleFlag(LDCONSTANTS.MAX_SIGNATURE_COUNT);
  const fetchSignatures = async () => {
    const res = await getUserSignature();

    if (res?.status === 200) {
      setSignatures(res.data);
    } else {
      toast.error(t.people.signature.failedSignature);
    }
  };

  useEffect(() => {
    fetchSignatures();
  }, []);

  const handleSignatureSave = async (dataURL, setLoading, setIsOpen) => {
    setLoading(true);
    try {
      const file = await imageUrlToFile(dataURL, "signature.png");
      const uploadRes = await uploadFile([file]);

      if (uploadRes?.status === 200) {
        const uploadedId = uploadRes.data[0].id;
        const createSignature = await addUserSignature(uploadedId);

        if (createSignature?.status === 200) {
          toast.success(t.people.signature.addSuccess);
          fetchSignatures();
          setIsOpen(false);
        } else if (createSignature?.status === 400) {
          toast.error(t.people.signature.addError);
        } else if (createSignature?.error?.message) {
          toast.error(createSignature?.error?.message);
        } else {
          toast.error(t.common.something_wrong);
        }
      } else {
        toast.error(t.common.something_wrong);
      }
    } catch (error) {
      toast.error(t.people.signature.addError);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSignature = (id) => {
    const selectedSig = addedSignature === id ? null : id;
    setAddedSignature(selectedSig);
  };

  return (
    <Modal
      className="assets-modal status-change-modal"
      size="tiny"
      open={openModal}
      onClose={() => {
        setModal(false);
      }}
    >
      <div
        className={
          approveModal || inProgressFlag
            ? "header-container green"
            : reOpenFlag
            ? "header-container reOpen"
            : inCancleFlag
            ? "header-container grey"
            : closeFlag
            ? "header-container close-data"
            : openFlag
            ? "header-container open"
            : "header-container red"
        }
      >
        <span className="assets-header">
          {" "}
          {`${
            inCancleFlag
              ? t.common.cancel
              : inProgressFlag
              ? t.workOrders.work_order_status.inProgress
              : reOpenFlag
              ? t.workOrders.work_order_status.reOpen
              : approveModal
              ? t.workOrders.complete
              : closeFlag
              ? t.workOrders.work_order_status.close
              : openFlag
              ? t.workOrders.work_order_status.open_status_action
              : t.workOrders.work_order_status.hold
          } `}
          {t.workOrders.details_view.work_order}
        </span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => setModal(false)}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content>
        <div className="comment-container">
          <label className="comment-label">
            {" "}
            {inCancleFlag
              ? t.workOrders.cancel_WO
              : inProgressFlag
              ? t.workOrders.progress_WO
              : reOpenFlag
              ? t.workOrders.reOpen_WO
              : approveModal
              ? t.workOrders.approve_WO
              : closeFlag
              ? t.workOrders.decline_WO
              : openFlag
              ? t.workOrders.open_WO
              : t.workOrders.hold_WO}
          </label>
          <div className="add-comment">
            <TextArea
              className="comment-textarea"
              rows={5}
              placeholder={`${
                !inCancleFlag && !openFlag && !reOpenFlag
                  ? t.workOrders.add_reason
                  : `${t.workOrders.required}`
              }`}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
        </div>

        {assigneeCondition ? (
          signatures?.data?.length < maxCount ? (
            <div className="form-button-container mt-4">
              <button
                className="form-action-button blue"
                onClick={() =>
                  openSignaturePad({
                    mode: "add",
                    image: "",
                    onSave: handleSignatureSave,
                    onCancel: () => {},
                  })
                }
              >
                {t.people.signature.add}
              </button>
            </div>
          ) : null
        ) : null}

        {signatures?.data?.length > 0 && assigneeCondition && (
          <>
            {addedSignature ? (
              <div className="mt-4">
                <label className="label-item">
                  {t.people.signature.selected}
                </label>
                <div
                  onClick={() => setAddedSignature(null)}
                  className="signature-box"
                >
                  <img
                    src={
                      signatures.data.find((sig) => sig.id === addedSignature)
                        .url
                    }
                    height={60}
                    className="signature-img"
                  />
                </div>
              </div>
            ) : null}

            <div className="mt-4">
              <label className="label-item">
                {t.people.signature.available}
              </label>
              <div className="d-flex flex-wrap sig-wrapper">
                {signatures.data.filter((sig) => sig.id !== addedSignature)
                  .length > 0 ? (
                  signatures.data
                    .filter((sig) => sig.id !== addedSignature)
                    .map((sig) => (
                      <div
                        key={sig.id}
                        className="signature-box"
                        onClick={() => handleSelectSignature(sig.id)}
                      >
                        <img
                          src={sig.url}
                          alt="Signature"
                          height={60}
                          className="signature-img"
                        />
                      </div>
                    ))
                ) : (
                  <div className="w-100 text-center">
                    <p>{t.people.signature.notAvailable}</p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        <div
          className={`modal-button-container ${
            selectedLanguage == "en" ? "mr-6" : "ml-10"
          }`}
        >
          <button
            className="modal-form-action-button"
            onClick={() => setModal(false)}
            disabled={loading}
          >
            {t.common.back}
          </button>

          <button
            onClick={() => {
              handleSave();
            }}
            className={`modal-form-action-button ${
              inProgressFlag
                ? "blue"
                : inCancleFlag
                ? "grey"
                : onHoldFlag
                ? "red"
                : reOpenFlag
                ? "purple"
                : approveModal
                ? "green"
                : closeFlag
                ? "dark-blue"
                : openFlag
                ? "blue"
                : "blue"
            }`}
          >
            {inCancleFlag
              ? t.assets.form.cancel
              : inProgressFlag
              ? t.workOrders.work_order_status.inProgress
              : approveModal
              ? t.workOrders.complete
              : reOpenFlag
              ? t.workOrders.work_order_status.reOpen
              : closeFlag
              ? t.workOrders.work_order_status.close
              : openFlag
              ? t.workOrders.work_order_status.open_status_action
              : t.workOrders.work_order_status.hold}
          </button>

          {SignaturePadModal()}
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default StatusChangeModal;
